// The minus sign of numbers formatted for Finnish (U+2212), which the number fields do not
// read back
const LOCALE_MINUS_SIGN = String.fromCharCode(0x2212);

/**
 * A number for an editable field, e.g. 1234,5: rounded to the given decimals (and shown
 * with them at most), a plain minus sign and no "-0", so the text reads back as the same
 * number.
 */
export default (
  value: number,
  roundToDecimals = 2,
  numberFormatOptions: any = { useGrouping: false }
): string => {
  if (Number.isNaN(value)) {
    return '0';
  }

  // + 0 turns a rounded -0 into 0
  const rounded =
    Math.round(value * 10 ** roundToDecimals) / 10 ** roundToDecimals + 0;

  return rounded
    .toLocaleString('fi', {
      maximumFractionDigits: roundToDecimals,
      ...numberFormatOptions,
    })
    .split(LOCALE_MINUS_SIGN)
    .join('-');
};
